import { ca } from '@cian/analytics';

export function trackBannerShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Show_sopr',
    label: 'independent_banner',
  });
}
